import React, { createContext, useState, useContext } from "react";
import PropTypes from "prop-types";
import { AppContext } from "../contextProvider";

/**
 * @typedef TopbarContext
 * @property {*} portalNode
 * @property {(node: *) => void} setPortalNode
 */

/** @type {React.Context<TopbarContext>} */

type Props = {
  children: any;
};

export const TopbarProvider = (props: Props) => {
  const [portalNode, setPortalNode] = useState();

  return (
    <AppContext.Provider value={{ portalNode, setPortalNode }}>
      {props.children}
    </AppContext.Provider>
  );
};

export const useTopbarContext = (): any => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error("useTopbarContext must be used in a TopbarProvider");
  }

  return context;
};

TopbarProvider.propTypes = {
  children: PropTypes.node
};

TopbarProvider.defaultProps = {
  children: null
};
